import ApiService from "@/common/api/api.service";

let apiBasePath = "LancamentoCaixa";
const FluxoCaixaService = {
  // FUNÇÕES DE BUSCA:
  async imprimirRecibo(ids) {
    let { data } = await ApiService.post(`${apiBasePath}/imprimir-recibo`, {
      ids: ids,
    });
    return data;
  },
  async gerarImpostoDeRendaPdf(matriculaId, anoLetivoId) {
    let { data } = await ApiService.get(
      `${apiBasePath}/relatorio-declaracao-imposto-renda`,
      {
        params: {
          matriculaId,
          anoLetivoId,
        },
      }
    );
    return data;
  },
};

export default FluxoCaixaService;
